import { Button } from 'atoms/Button';
import { useTranslations } from 'modules/i18n/useTranslations';
import { useRouter } from 'modules/next/hooks';
import { AppRoutes } from 'modules/shop/routes';
import { useUser } from 'modules/shop/user/hooks';
import { SidebarNavigation } from '../SidebarNavigation';
import styles from './styles.module.css';

export const SidebarContent = () => {
  const router = useRouter();
  const t = useTranslations();
  const { user, logout } = useUser();

  const handleLogout = async () => {
    await logout();
    router.push(AppRoutes.LOGIN as string);
  };

  return (
    <div className={styles.root}>
      <SidebarNavigation />
      <div className={styles.container}>
        {!!user ? (
          <>
            <Button href={AppRoutes.ACCOUNT} theme="light">
              {t('common.buttons.customer-account')}
            </Button>
            <Button onClick={handleLogout} theme="light">
              {t('common.buttons.logout')}
            </Button>
          </>
        ) : (
          <Button href={AppRoutes.LOGIN as string} theme="light">
            {t('common.buttons.registration')}
          </Button>
        )}
      </div>
    </div>
  );
};
